import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import styled from "styled-components";
import { fetchLocation } from "../actions";
import { capitalize } from "../utils/FrontEndHelpers";

const GuestPage = () => {
  const { locationId, vendorId } = useParams();
  //   const history = useHistory();
  const [location, setLocation] = useState([]);
  const [licensePlate, setLicensePlate] = useState("");
  const [licenseState, setLicenseState] = useState("");
  const [validationCode, setValidationCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [session, setSession] = useState(null);
  const [error, setError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const getData = async () => {
    const l = await fetchLocation(locationId);

    console.log("line 29", l);
    setLocation(l);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = {
      code: validationCode.toUpperCase(),
      locationId: locationId,
      licensePlate: licensePlate,
      licenseState: licenseState,
      vendorId: vendorId,
    };

    try {
      setIsLoading(true);
      setError("");

      const res = await fetch("/api/v1/sessions/validate", {
        method: "POST",
        body: JSON.stringify(dataToSend),
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("res", res);

      if (!res.ok) {
        throw new Error(
          "Hmm, looks like something went wrong, Please try again"
        );
      }

      const data = await res.json();
      console.log("data", data);

      setSession(data.session);
      setIsSuccess(true);
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Header>
        <Logo>
          <LogoText>
            <LogoO>o</LogoO>
            <LogoP>p</LogoP>
            <LogoS>s</LogoS>
          </LogoText>
          {/* <LogoBadge /> */}
        </Logo>
        <Title>
          {isSuccess
            ? `Parking Validation Successfully Registered!`
            : `Welcome to ${capitalize(
                location?.name
              )} Guest Parking Registration`}
        </Title>
      </Header>
      {!isSuccess ? (
        <Content>
          <Instructions>
            To park here as a guest, you must register your license plate and
            obtain a validation code from the business you're visiting.
          </Instructions>
          <form onSubmit={handleSubmit}>
            <div>
              <div>
                <Input
                  type="text"
                  placeholder="License Plate Number"
                  value={licensePlate}
                  onChange={(e) =>
                    setLicensePlate(e.target.value.toUpperCase())
                  }
                  required
                  disabled={isLoading}
                  maxLength={8}
                />
                <Input
                  type="text"
                  placeholder="License Plate State"
                  value={licenseState}
                  onChange={(e) =>
                    setLicenseState(e.target.value.toUpperCase())
                  }
                  required
                  disabled={isLoading}
                  maxLength={2}
                />
              </div>
              <div>
                <Input
                  type="text"
                  placeholder="Validation Code"
                  value={validationCode}
                  onChange={(e) =>
                    setValidationCode(e.target.value.toUpperCase())
                  }
                  required
                  disabled={isLoading}
                />
              </div>
            </div>
            <ValidationNote>
              Obtain a validation code from the business you're visiting.
            </ValidationNote>
            <ActionButton
              type="submit"
              disabled={isLoading}
              onClick={handleSubmit}
            >
              {isLoading ? "Validating..." : "Validate Parking"}
            </ActionButton>
          </form>
        </Content>
      ) : (
        <Content>
          <Instructions>
            Thank you for registering your license plate for{" "}
            <strong>{location?.name}</strong>. Please park your car and enjoy
            your visit.
          </Instructions>
          <Instructions style={{ textTransform: "uppercase" }}>
            <strong>Reference Number:</strong> {session?.referenceNumber}
          </Instructions>
        </Content>
      )}
      {error && (
        <div style={{ color: "red", textAlign: "center" }}>{error}</div>
      )}
    </div>
  );
};

// Styled components
const Header = styled.div`
  background-color: #12b981;
  padding: 20px;
  text-align: center;
`;

const Logo = styled.div`
  width: 100px;
  height: 100px;
  background-color: white;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const LogoText = styled.div`
  font-size: 40px;
  font-weight: bold;
  color: #6ebb45;
  position: relative;
`;

const LogoO = styled.span`
  position: relative;
  top: -5px;
`;

const LogoP = styled.span`
  font-size: 60px;
`;

const LogoS = styled.span`
  position: relative;
  top: -5px;
`;

const Title = styled.h1`
  color: white;
  font-size: 28px;
  margin: 0;
  font-weight: 500;
  line-height: 1.2;
`;

const Content = styled.div`
  padding: 30px 20px;
`;

const Instructions = styled.p`
  color: #666;
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 30px;
`;

const Input = styled.input`
  width: 100%;
  padding: 15px 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  background-color: #f0f0f0;
  font-size: 18px;
  box-sizing: border-box;
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #3a9b9b;
  }
`;

const ValidationNote = styled.p`
  color: gray;
  font-size: 16px;
  margin: 15px 0 30px;
  font-style: italic;
  text-align: center;
`;

const ActionButton = styled.button`
  height: 70px;
  width: 300px;
  margin-top: 20px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  background-color: #12b981;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.2s;
  display: block;
  margin: 0 auto;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  &:hover {
    background-color: #2cc36b;
  }
`;

export default GuestPage;
